import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'marcas'
})
export class MarcasPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
